import { createTheme } from '@mui/material/styles';

import components from './components';
import palette from './palette';
import mixins from './mixins';

const theme = createTheme({
  components,
  palette,
  mixins
});

// TODO: Remove usage of the theme directly imported from here, we need to override the
//       palette dynamically based on received primary and secondary color. See ThemeProvider usage.
export default theme;
